/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Toast_GeneratedInputs */

const en_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const de_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const fr_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const es_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const it_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const nl_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const pl_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const fi_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const da_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

const sv_story_bank_toast_generated = /** @type {(inputs: Story_Bank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stories generated`)
};

/**
* | output |
* | --- |
* | "Stories generated" |
*
* @param {Story_Bank_Toast_GeneratedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_toast_generated = /** @type {((inputs?: Story_Bank_Toast_GeneratedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Toast_GeneratedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_toast_generated(inputs)
	if (locale === "fr") return fr_story_bank_toast_generated(inputs)
	if (locale === "es") return es_story_bank_toast_generated(inputs)
	if (locale === "it") return it_story_bank_toast_generated(inputs)
	if (locale === "nl") return nl_story_bank_toast_generated(inputs)
	if (locale === "pl") return pl_story_bank_toast_generated(inputs)
	if (locale === "fi") return fi_story_bank_toast_generated(inputs)
	if (locale === "da") return da_story_bank_toast_generated(inputs)
	if (locale === "sv") return sv_story_bank_toast_generated(inputs)
	return en_story_bank_toast_generated(inputs)
});